import { MobileBFFGuides, Guides } from '@/src/homepage/types/guides';
import { getPlaceFromLocationSlug } from '../../geo/getPlaceFromLocationSlug';
import { IncomingMessage } from 'http';
import { getRequestContext } from '@/src/homepage/utils/requestContext';
import { hydrateGuideLocation } from './hydrateGuideLocation';
import { getMobileBffApiGateway } from './utils';

const emptyGuides: Guides = {
    items: [],
    totalSize: 0,
    pageSize: 0,
};

type Location = {
    latitude?: number;
    longitude?: number;
    slug: string;
};

export async function getGuides(req: IncomingMessage, place: Location) {
    if (!place.slug) {
        console.warn('Place is missing a location slug');
        return emptyGuides;
    }

    const { host } = getRequestContext(req);

    try {
        let latitude = place.latitude;
        let longitude = place.longitude;

        if (!latitude || !longitude) {
            const placeData = await getPlaceFromLocationSlug(place.slug);
            if (!placeData?.latitude || !placeData?.longitude) {
                console.warn('No place found for slug', place.slug);
                return emptyGuides;
            }
            latitude = placeData.latitude as number;
            longitude = placeData.longitude as number;
        }

        const locationParam = encodeURIComponent(
            JSON.stringify({
                latitude,
                longitude,
            }),
        );

        const mobileBffApiGw = getMobileBffApiGateway();
        const originKey = process.env.MOBILE_BFF_X_EB_ORIGIN_KEY;
        const response = await fetch(
            `https://${mobileBffApiGw}/guides/mobile-bff/api/temp/guides?curated=true&location=${locationParam}`,
            {
                method: 'GET',
                headers: {
                    ...(originKey && { 'x-eb-origin-key': originKey }),
                    host,
                    Referer: `https://${host}`,
                },
            },
        );
        const guides: MobileBFFGuides = await response.json();

        const hydratedGuides = await Promise.all(
            guides.items.map((guide) => hydrateGuideLocation(guide, place.slug)),
        );

        return {
            ...guides,
            items: hydratedGuides,
        };
    } catch (e) {
        console.error('Error fetching guides:', e);
        throw e;
    }
}
